import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../style/imges/hopalogo.png';
import { useI18n } from '../../i18n/I18nContext';
import '../../style/css/public2026.css';

// Lightweight shared shell for public (logged-out) pages: branded header + gray canvas.
// Full marketing landing lives in MarketingLanding.js; directory/business pages use this
// shell until their rich content is built.
//
// i18n: this shell owns the PUBLIC dir switch — it sets `dir` on its OWN root div (never on
// <html>), so the internal management app's RTL is unaffected. Hebrew is the default.
export default function PublicShell({ children }) {
    const { t, dir, locale, setLocale } = useI18n();
    return (
        <div className="pub-root" dir={dir}>
            <header className="pub-header">
                <Link to="/welcome" className="pub-logo-link">
                    <img src={logo} alt="HOPPA" className="pub-logo" />
                </Link>
                <nav className="pub-nav">
                    <Link to="/discover" className="pub-nav-link">{t('nav.discover')}</Link>
                    <Link to="/my" className="pub-nav-link">{t('nav.my')}</Link>
                    <Link to="/login" className="pub-nav-link pub-nav-cta">{t('nav.login')}</Link>
                    <div className="pub-lang" role="group" aria-label={t('nav.langLabel')}>
                        <button
                            type="button"
                            className={`pub-lang-btn${locale === 'he' ? ' is-active' : ''}`}
                            aria-pressed={locale === 'he'}
                            onClick={() => setLocale('he')}
                        >עב</button>
                        <button
                            type="button"
                            className={`pub-lang-btn${locale === 'en' ? ' is-active' : ''}`}
                            aria-pressed={locale === 'en'}
                            onClick={() => setLocale('en')}
                        >EN</button>
                    </div>
                </nav>
            </header>
            <main className="pub-main">{children}</main>
        </div>
    );
}
